import { MinimalHeader } from '@bosch/react-frok'

import Footer from '@/ui/components/Footer/Footer'

import StartupSplash from './StartupSplash'
import type { StartupSplashProps } from './StartupSplash'

import './StartupScreen.scss'

/** The whole screen of the startup: the Bosch header with its supergraphic and logo, the splash, the footer. */
const StartupScreen = (props: StartupSplashProps) => (
    <div className="startup-screen">
        {/* no link on the logo: the screen is shown outside of the router */}
        <MinimalHeader />
        <div className="startup-screen-content">
            <StartupSplash {...props} />
        </div>
        <Footer show={true} />
    </div>
)

export default StartupScreen
